export default __webpack_public_path__ + "static/701-705-710-715-631547bd61ed9371fdab126689976265.jpg";